import { createSelector } from 'reselect';

const selectMenu = (state) => state.menu;

export const selectListaEstados = createSelector(
  [selectMenu],
  (menu) => menu.estados ? Object.values(menu.estados) : []
);

export const selectEstados = createSelector(
  [selectMenu],
  (menu) => menu.estados
);

export const selectEstado = createSelector(
  [selectMenu, selectEstados],
  (menu, estados) => estados ? estados[menu.idEstado] : undefined
);

export const selectProcesos = createSelector(
  [selectEstado],
  (estado) => estado && estado.procesos ? estado.procesos : undefined
);

export const selectListaProcesos = createSelector(
  [selectEstado],
  (estado) => estado && estado.procesos ? Object.values(estado.procesos) : []
);

export const selectProceso = createSelector(
  [selectMenu, selectProcesos],
  (menu, procesos) => procesos ? procesos[menu.idDetalle] : undefined
);

export const selectListaDistritos = createSelector(
  [selectProceso],
  (proceso) => {
    if(!proceso || !proceso.distritos) return [];
    return Object.values(proceso.distritos);
  }
);

export const selectDistrito = createSelector(
  [selectMenu, selectProceso],
  (menu, proceso) => proceso && proceso.distritos ? proceso.distritos[menu.idDistrito] : undefined
);

export const selectParticipacion = createSelector(
  [selectDistrito],
  (distrito) => distrito && distrito.idParticipacion ? distrito.idParticipacion : undefined
);

export const selectRutaPublicador = createSelector(
  [selectProceso],
  (proceso) => proceso && proceso.rutaPublicador ? proceso.rutaPublicador : undefined
);